import { useQuery } from '@tanstack/react-query';
import { type LandingCategoryType } from '@/common/types/landingCategory.type';
import { type ResponseItemsType } from '@/common/types/response.type';
import Client from '@/common/utils/client.utility';

export type LandingCategoriesType = () => Promise<
  ResponseItemsType<LandingCategoryType>
>;

export const LANDING_CATEGORIES_QUERY_KEY = ['Get-Landing-Categories'];

export const LandingCategoriesApi: LandingCategoriesType = async () => {
  const client = new Client(true);
  return await client.get(`/v1/Category/Landing`);
};

export const useLandingCategories = () =>
  useQuery({
    queryKey: LANDING_CATEGORIES_QUERY_KEY,
    queryFn: LandingCategoriesApi,
    staleTime: 60_000,
  });
